// extracted by mini-css-extract-plugin
export default {"avatar":"V8gwZj","withNewColorWiring":"pj_OjB","memberInitials":"ZeCqr2","withBorder":"CiSb4N","avatarPlaceholder":"aBATL4","loggedOut":"b2cSkJ"};